import { ShimmerProps } from './Shimmer.types';
import { getClasses } from '@/_utils/classnames';
import styles from './Shimmer.module.css';
import type { FC } from 'react';

const Shimmer: FC<ShimmerProps> = ({
  isRounded,
  isRound,
  isFullWidth,
  paddingInline,
  paddingTop,
  paddingBottom,
  height,
  width,
  className,
}) => {
  const shimmerContainerClasses: string = getClasses(className, styles.shimmer);
  const shimmerDivClasses: string = getClasses({
    [styles.shimmerRound]: isRound,
    [styles.shimmerRounded]: isRounded,
    [styles.shimmerNormal]: !isRounded && !isRound,
  });

  return (
    <div
      className={shimmerContainerClasses}
      style={{
        height: height + 'px',
        paddingTop: (paddingTop ?? 0) + 'px',
        paddingInline: (paddingInline ?? 0) + 'px',
        paddingBottom: (paddingBottom ?? 0) + 'px',
        width: isFullWidth ? '100%' : width + 'px',
        minWidth: isFullWidth ? '100%' : width + 'px',
      }}
    >
      <div className={shimmerDivClasses} />
    </div>
  );
};

export { Shimmer };
